import * as React from 'react';
import { usePromptStarter_unstable } from './usePromptStarter';
import { renderPromptStarter_unstable } from './renderPromptStarter';
import { usePromptStarterStyles_unstable } from './usePromptStarterStyles.styles';
import { useCustomStyleHook } from '@fluentui-copilot/react-provider';
import type { PromptStarterProps } from './PromptStarter.types';
import type { ForwardRefComponent } from '@fluentui/react-components';

/**
 * @deprecated Use PromptStarterV2 instead.
 * Deprecated on 10/21/2025
 */
export const PromptStarter: ForwardRefComponent<PromptStarterProps> = React.forwardRef((props, ref) => {
  const state = usePromptStarter_unstable(props, ref);

  usePromptStarterStyles_unstable(state);
  useCustomStyleHook('usePromptStarterStyles')(state);

  return renderPromptStarter_unstable(state);
});

PromptStarter.displayName = 'PromptStarter';
